<template>
  <section v-if="model" class="table-sampler-classification-chemical">
    <d-button id="updateButton" class="btn d-flex mb-2 ml-auto" @click.prevent="updateClassifications()">Atualizar Classificações</d-button>
    <d-form-row class="m-0 mb-1" v-for="(classification, index) in model.classifications" v-bind:key="index">
      <d-col cols="3">
        <label>Agente Químico</label>
        <input
          type="text"
          class="form-control"
          placeholder="Agente quimico"
          v-model="classification.agent_chemical"
          required
        />
      </d-col>
      <d-col cols="auto">
        <label>Indice de risco</label>
         <select type="text" class="form-control" v-model="classification.index" required>
          <option v-if="!Object.values(optionsIndex).includes(classification.index)" :value="classification.index">{{ classification.index }}</option>
          <option v-for="(option, index) in optionsIndex" :value="option" :key="index">{{ option }}</option>
        </select>
      </d-col>
      <d-col cols="auto">
        <label>% LEO</label>
        <select type="text" class="form-control" v-model="classification.leo" required>
          <option v-if="!Object.values(optionsLEO).includes(classification.leo)" :value="classification.leo">{{ classification.leo }}</option>
          <option v-for="(option, index) in optionsLEO" :value="option" :key="index">{{ option }}</option>
        </select>
      </d-col>
      <d-col cols>
        <label>Frequência de amostragem</label>
        <select type="text" class="form-control" v-model="classification.frequency" required>
          <option v-if="!Object.values(optionsFrequency).includes(classification.frequency)" :value="classification.frequency">{{ classification.frequency }}</option>
          <option v-for="(option, index) in optionsFrequency" :value="option" :key="index">{{ option }}</option>
        </select>
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="12">
        <label>Recomendação da exposição</label>
        <textarea
          type="text"
          class="form-control"
          v-model="model.recommendation"
          required
        ></textarea>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { mapActions } from 'vuex';
import { CHEMICAL } from '_modules/settings/components/SettingsModel';
import { CHEMICAL_CLASSIFICATION, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Classification-Chemical',
  props: {
    classification: {
      type: Object,
      default: null,
    },
    result: {
      type: Array,
      default: null,
    },
  },
  computed: {
    chemicalSettings() {
      const { chemicalResult } = this.$store.state.settings;
      if (chemicalResult) {
        return chemicalResult;
      }
      return { ...CHEMICAL };
    },
  },
  data() {
    return {
      model: cloneDeep(CHEMICAL_CLASSIFICATION),
      isInitialLoad: true,
      optionsIndex: {
        lowRisk: '',
        mediumRisk: '',
        highRisk: '',
      },
      optionsFrequency: {
        lowRisk: '',
        mediumRisk: '',
        highRisk: '',
      },
      optionsLEO: {
        lowRisk: '',
        mediumRisk: '',
        highRisk: '',
      },
    };
  },
  methods: {
    ...mapActions([
      'getSettings',
    ]),
    setModel() {
      if (this.result) {
        if (this.classificationsExist()) {
          this.model = this.classification;
          return;
        }
        this.updateClassifications();
      }
    },
    updateClassifications() {
      this.model = this.setClassifications();
    },
    convertToNumber(value) {
      if (value) {
        return parseFloat(value.toString().replace(/,/g, '.'));
      }
      return null;
    },
    formatPercentage(value) {
      const percentage = value * 100;
      return percentage % 1 === 0 ? percentage : percentage.toFixed(2);
    },
    setSelectOptions() {
      const lowRiskFloat = this.convertToNumber(this.chemicalSettings.lowRisk);
      const mediumRisk1Float = this.convertToNumber(this.chemicalSettings.mediumRisk1);
      const mediumRisk2Float = this.convertToNumber(this.chemicalSettings.mediumRisk2);
      const highRiskFloat = this.convertToNumber(this.chemicalSettings.highRisk);

      this.optionsIndex.lowRisk = `< ${lowRiskFloat}`;
      this.optionsLEO.lowRisk = `< ${this.formatPercentage(lowRiskFloat)}%`;
      this.optionsFrequency.lowRisk = `Bianulmente até reduzir para menor que ${this.formatPercentage(lowRiskFloat)}% do limite`;

      this.optionsIndex.mediumRisk = `>= ${mediumRisk1Float} e <= ${mediumRisk2Float}`;
      this.optionsLEO.mediumRisk = `>= ${this.formatPercentage(mediumRisk1Float)}% e <= ${this.formatPercentage(mediumRisk2Float)}%`;
      this.optionsFrequency.mediumRisk = `Semestralmente até reduzir para maior que ${this.formatPercentage(mediumRisk1Float)}% e menor que ${this.formatPercentage(mediumRisk2Float)}% do limite`;

      this.optionsIndex.highRisk = `> ${highRiskFloat}`;
      this.optionsLEO.highRisk = `> ${this.formatPercentage(highRiskFloat)}%`;
      this.optionsFrequency.highRisk = `Frequentemente até reduzir para menor que ${this.formatPercentage(highRiskFloat)}% do limite`;
    },
    setClassifications() {
      const classificationsList = [];
      const recommendationText = this.classification && this.classification.recommendation ? this.classification.recommendation : '';

      this.result.forEach(r => {
        const classification = this.setClassificationValues(r);
        classificationsList.push(classification);
      });

      return {
        recommendation: recommendationText,
        classifications: classificationsList,
      };
    },
    setClassificationValues(result) {
      return {
        agent_chemical: result.agent_chemical || '',
        leo: this.optionsLEO[result.risk_level] || '',
        index: this.optionsIndex[result.risk_level] || '',
        frequency: this.optionsFrequency[result.risk_level] || '',
      };
    },
    classificationsExist() {
      return !!(this.classification && this.classification.classifications);
    },
  },
  mounted() {
    this.getSettings().then(() => {
      this.setSelectOptions();
      this.setModel();
    });
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:classification', value);
      },
      deep: true,
    },
    result: {
      handler() {
        if (this.isInitialLoad) {
          this.isInitialLoad = false;
        } else {
          this.updateClassifications();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
